import type { ImageSearchItem } from '../types/imageSearch.types';
import { ImagesInfiniteListView } from './ImagesInfiniteListView';
export const PexelsInfiniteListView = ({
  images,
  hasNextPage,
  onLoadMore,
  onImageSelect,
  isLoadingMore
}: {
  images: ImageSearchItem[];
  hasNextPage: boolean;
  onLoadMore: () => void;
  onImageSelect: (image: ImageSearchItem) => void;
  isLoadingMore: boolean;
}) => {
  return <ImagesInfiniteListView.Container hasNextPage={hasNextPage} isLoadingMore={isLoadingMore} onLoadMore={onLoadMore} data-sentry-element="unknown" data-sentry-component="PexelsInfiniteListView" data-sentry-source-file="PexelsInfiniteListView.tsx">
      <ImagesInfiniteListView.Content data-sentry-element="unknown" data-sentry-source-file="PexelsInfiniteListView.tsx">
        {images.map(image => <ImagesInfiniteListView.Item key={image.id} image={image} onImageSelect={onImageSelect} />)}
      </ImagesInfiniteListView.Content>
      {isLoadingMore && <ImagesInfiniteListView.Loading />}
    </ImagesInfiniteListView.Container>;
};